const mod = crateImports["@xing-com/crate-communication-in-view"];
const { Observed,Observer,ObserverContext,InViewTracking } = mod;
export { Observed,Observer,ObserverContext,InViewTracking };
export default mod.default ?? mod;